import { fetchPositions, fetchHoldings, convertPosition } from "../../services/backendAPI/index";
import {
  getFormattedPosition,
  getFormattedHolding,
} from "../../utils/portfolio";
import {fetchOrder, getAllIpo, cancelAMOOrder} from "../../services/backendAPI";



export const fetchPositionsAction = (
  positionType='historical',
  isBackOfficeEnabled,
  oms
) => (dispatch) => {
  fetchPositions(positionType)
    .then(({ data }) => {
      const positions = data.map((position) => {
        // Ensure we have a valid LTP value
        // const ltp = (position.ltp !== undefined && position.ltp !== null && position.ltp > 0) 
        //   ? position.ltp 
        //   : (position.previous_close || 0);
          
        // // Ensure previous_close is not zero
        // if (position.previous_close === undefined || position.previous_close === null || position.previous_close === 0) {
        //   position.previous_close = ltp;
        // }
        
        // Pass ltp as the second parameter - this is critical for PnL calculation
        const formattedPosition = getFormattedPosition(
          position, 
          position.ltp, 
          positionType, 
          isBackOfficeEnabled, 
          oms
        );
        
        return formattedPosition;
      });
      
      dispatch({
        type: "SET_POSITIONS",
        payload: positions,
      });
      dispatch({
        type: "SET_POSITIONS_UPDATE",
        payload: positions,
      });
    })
    .catch((err) => dispatch({
      type: 'SET_POSITIONS_ERROR_MESSAGE',
      payload: err
    }));
};

export const fetchHoldingsAction = (oms, brokerName, quantityConfig, productCode) => (dispatch) => {
  fetchHoldings(productCode)
    .then(({ data }) => {
      const holdings = data.holdings.map((holding) =>
        getFormattedHolding(holding, oms, brokerName, quantityConfig)
      );
      dispatch({
        type: "SET_HOLDINGS",
        payload: holdings,
      });
      dispatch({
        type: "SET_HOLDINGS_UPDATE",
        payload: holdings,
      });
    })
    .catch((err) => dispatch({
      type: 'SET_HOLDINGS_ERROR_MESSAGE',
      payload: err
    }));
};

export const executeConvertPositionAction = (position, quantity, targetProduct) => dispatch => {
  if (!position || !quantity || !targetProduct) {
    console.error("Missing parameters:", { position, quantity, targetProduct });
    throw new Error(`Missing required parameters: ${!position ? 'position' : ''} ${!quantity ? 'quantity' : ''} ${!targetProduct ? 'targetProduct' : ''}`);
  }

  const payload = {
    product: position.product,
    exchange: position.exchange,
    quantity: quantity,
    validity: position.cf_buy_quantity > 0 ? "CF" : "DAY",
    // instrument_type: "FUTCOM",
    client_id: localStorage.getItem("login_id"),
    order_side: position.net_quantity > 0 ? "SELL" : "BUY",
    new_product: targetProduct,
    instrument_token: position.token
  };
  return convertPosition(payload)
    .then((response) => {
      dispatch({
        type: 'SET_CONVERT_POSITION',
        payload: response.data
      });
      return response;
    })
    .catch(err => {
      console.error('Position conversion error:', err);
      throw err;
    });
};

export const fetchAllIPOsAction = () => dispatch => {
  getAllIpo()
    .then(({data}) => {
      dispatch({
        type: 'SET_ALL_IPOS',
        payload: data
      })
    })
    .catch(err => console.log(err));
}

export const fetchOrdersAction = () => dispatch => {
  fetchOrder()
    .then(({data}) => {
      dispatch({
        type: 'SET_IPO_ORDERS',
        payload: data
      })
    })
    .catch(err => console.log(err));
}
export const fetchAMOOrdersAction = () => dispatch => {
  cancelAMOOrder()
    .then(({data}) => {
      dispatch({
        type: 'SET_AMO_IPO_ORDERS',
        payload: data
      })
    })
    .catch(err => console.log(err));
}
